import * as Cookies from 'js-cookie';
import {
  AuthActions,
  LOGOUT,
  SET_AUTH,
  SET_IS_BOT,
} from 'actions/auth';

export type AuthReducerState = {
  userId: string,
  sessionToken: string,
  isLoggedIn: boolean,
  isAnonymousUser: boolean,
  isBot?: boolean,
};

const getDefaultState = (): AuthReducerState => ({
  userId: typeof Cookies !== 'undefined' ? Cookies.get('userId') || '' : '',
  sessionToken: typeof Cookies !== 'undefined' ? Cookies.get('token') || '' : '',
  isLoggedIn: typeof Cookies !== 'undefined' ? Boolean(Cookies.get('userId') && Cookies.get('token')) : false,
  isAnonymousUser: false,
  isBot: false,
});

export function authReducer(state = getDefaultState(), action: AuthActions): AuthReducerState {
  switch (action.type) {
    case SET_AUTH: {
      const {
        sessionToken,
        userId,
        isAnonymousUser,
      } = action;

      return {
        ...state,
        sessionToken,
        userId,
        isLoggedIn: Boolean(sessionToken && userId),
        isAnonymousUser,
      };
    }

    case SET_IS_BOT: {
      const {
        isBot,
      } = action;

      return {
        ...state,
        isBot,
      };
    }

    case LOGOUT: {
      return getDefaultState();
    }
  }

  return state;
}
